const initialState = {
  list: {
    isLoading: false,
    error: '',
    paginationOptions: {
      page: 1,
      size: 50,
      name__icontains: '',
    },
    data: {
      items: [],
      count: 0,
    },
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  add: {
    isLoading: false,
    error: '',
  },
  update: {
    isLoading: false,
    error: '',
  },
  delete: {
    isLoading: false,
    error: '',
  },
};

export default initialState;
